import Text from 'components/Text/Text';

export default Text;
